import { createStyles } from "src/styles/theme";

export type StylesClasses = keyof typeof styles;

const styles = createStyles({
  container: {},
  children: {
    marginTop: "5px",
    padding: "5px",
    backgroundColor: "white",
  },
});

export default styles;
